import { useState, useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import { BakeShadows, AccumulativeShadows, RandomizedLight, SoftShadows } from '@react-three/drei';

const ShadowHandler = ({ isBaked, setIsBakingParent }) => {
  const [isBaking, setIsBaking] = useState(false);
  const accumulativeShadowsRef = useRef();
  const targetFrames = 100;
  const frameCountRef = useRef(0);


  const handleFrameCompletion = () => {
    console.log("frameCount >= " + targetFrames);
    setIsBaking(true);
  };

  useFrame(({ scene }) => {
    if (!isBaking && accumulativeShadowsRef.current) {
      frameCountRef.current++;
      console.log("frameCount: " + frameCountRef.current);
      if (frameCountRef.current >= targetFrames) {
        handleFrameCompletion();
      }
      // Notify parent component
      if (typeof setIsBakingParent === 'function') {
        setIsBakingParent(true);
      }
    }
  });

  //This is now working, but it's sampling shadows twice
  return (
    <>
      <AccumulativeShadows
        temporal
        frames={targetFrames}
        scale={5}
        opacity={1}
        resolution={2048}
        ref={accumulativeShadowsRef}
      >
        <RandomizedLight
          amount={2}
          position={[0, 1, 0]}
          radius={5}
        />
      </AccumulativeShadows>
      {/* {isBaking && (
        <>
        <BakeShadows />
        <SoftShadows samples={16} size={10}/>
        </>
        )} */}
    </>
  );
};

export default ShadowHandler;